/**
 * Fiskal Cloud Admin ELSTER Registration API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Definition of email for notification. Each email address can have own language setting.
 */
export interface EmailNotificationDetailDTO { 
    /**
     * Additional email addresses to which notification will be sent
     */
    email?: string;
    /**
     * Language in which the notification should be sent
     */
    language?: EmailNotificationDetailDTOLanguageEnum;
}

export class ClsEmailNotificationDetailDTO { 
    /**
     * Additional email addresses to which notification will be sent
     */
    email?: string = undefined;
    /**
     * Language in which the notification should be sent
     */
    language?: EmailNotificationDetailDTOLanguageEnum = undefined;
}
export enum EmailNotificationDetailDTOLanguageEnum {
    DE = 'de',
    EN = 'en'
}

export class ClsEmailNotificationDetailDTOLanguageEnum {
    DE = 'de';
    EN = 'en';
};



